/* RETROBELTXP — theme script (no dependencies, ~6 KB) */
(() => {
  const C = Object.assign({ cartUrl: '/cart', locale: 'es-ES', currency: 'EUR', fallbackImg: '', demo: false, product: null }, window.RBXP || {});
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const money = c => (c / 100).toLocaleString(C.locale, { style: 'currency', currency: C.currency });
  document.documentElement.classList.remove('no-js');

  /* ---------- windows "open" as they enter the screen ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { threshold: .1, rootMargin: '0px 0px -40px 0px' });
    $$('[data-open]').forEach(el => io.observe(el));
  } else $$('[data-open]').forEach(el => el.classList.add('is-in'));

  /* ---------- loading bar ---------- */
  $$('[data-load]').forEach(load => new IntersectionObserver((es, o) => es.forEach(e => {
    if (!e.isIntersecting) return; o.disconnect(); load.classList.add('is-in');
    const pct = $('[data-pct]', load); let n = 0;
    const t = setInterval(() => { n = Math.min(100, n + 5); pct.textContent = n + '%'; if (n === 100) clearInterval(t); }, 80);
  }), { threshold: .5 }).observe(load));

  /* ---------- sticky header state ---------- */
  const head = $('.rbxp-head');
  if (head) addEventListener('scroll', () => head.classList.toggle('is-stuck', scrollY > 40), { passive: true });

  /* ---------- START menu ---------- */
  const sb = $('[data-start]'), sm = $('[data-start-menu]');
  const closeStart = () => { if (!sm) return; sm.classList.remove('is-open'); sb && sb.setAttribute('aria-expanded', 'false'); };
  sb && sb.addEventListener('click', e => { e.stopPropagation(); const o = sm.classList.toggle('is-open'); sb.setAttribute('aria-expanded', o); });
  sm && $$('a', sm).forEach(a => a.addEventListener('click', closeStart));
  document.addEventListener('click', e => { if (sm && sm.classList.contains('is-open') && !sm.contains(e.target)) closeStart(); });

  /* ---------- galleries / IMAGE_VIEWER ---------- */
  const zd = $('[data-zoom-dialog]'), zi = $('[data-zoom-img]');
  $$('[data-viewer]').forEach(v => {
    const slides = $$('[data-slide]', v), thumbs = $$('[data-thumb]', v), count = $('[data-count]', v), cap = $('[data-cap]', v);
    let i = 0;
    const go = n => {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k !== i); });
      thumbs.forEach(t => { const on = +t.dataset.thumb === i; t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (cap) cap.textContent = slides[i].dataset.name || '';
    };
    thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.thumb)));
    $$('[data-prev]', v).forEach(b => b.addEventListener('click', () => go(i - 1)));
    $$('[data-next]', v).forEach(b => b.addEventListener('click', () => go(i + 1)));
    $$('[data-zoom]', v).forEach(b => b.addEventListener('click', () => {
      const s = slides[i]; if (!s || !s.dataset.full || !zd || !zd.showModal) return;
      zi.src = s.dataset.full; zi.alt = ($('img', s) || {}).alt || ''; zd.showModal();
    }));
    let x0 = null;
    v.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    v.addEventListener('touchend', e => {
      if (x0 === null || slides.length < 2) return;
      const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null;
    });
    go(0);
  });
  $('[data-zoom-close]') && $('[data-zoom-close]').addEventListener('click', () => zd.close());
  zd && zd.addEventListener('click', e => { if (e.target === zd) zd.close(); });

  /* ---------- LAUNCH OFFER "close" → it refuses ---------- */
  $$('[data-noclose]').forEach(b => b.addEventListener('click', () => {
    const w = b.closest('.w'); w.classList.remove('rbxp-shake'); void w.offsetWidth; w.classList.add('rbxp-shake');
  }));

  /* ---------- quantity steppers ---------- */
  $$('[data-qty]').forEach(b => b.addEventListener('click', () => {
    const inp = b.parentElement.querySelector('input');
    inp.value = Math.max(1, Math.min(10, (+inp.value || 1) + (+b.dataset.qty)));
  }));

  /* ---------- cart API (real Shopify, or in-memory demo for the preview) ---------- */
  const demo = { items: [] };
  const demoCart = () => {
    const items = demo.items.map(it => Object.assign({}, it, { final_line_price: it.price * it.quantity }));
    return { items, item_count: items.reduce((a, b) => a + b.quantity, 0), total_price: items.reduce((a, b) => a + b.final_line_price, 0) };
  };
  const api = {
    get: () => C.demo ? Promise.resolve(demoCart())
      : fetch(C.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json()),
    add: fd => {
      if (C.demo) {
        const q = +fd.get('quantity') || 1, ex = demo.items[0];
        if (ex) ex.quantity += q; else demo.items.push(Object.assign({ quantity: q }, C.product));
        return Promise.resolve();
      }
      return fetch(C.cartUrl + '/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(r => r.json().then(j => { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }));
    },
    change: (line, quantity) => {
      if (C.demo) { const it = demo.items[line - 1]; if (it) { it.quantity = quantity; if (!quantity) demo.items.splice(line - 1, 1); } return Promise.resolve(demoCart()); }
      return fetch(C.cartUrl + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) }).then(r => r.json());
    }
  };

  const cart = $('[data-cart]');
  if (cart) {
    const items = $('[data-cart-items]', cart), total = $('[data-cart-total]', cart), checkout = $('[data-checkout]', cart);
    let lastFocus = null;
    const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const img = u => u ? u + (u.includes('?') ? '&' : '?') + 'width=180' : C.fallbackImg;
    const paint = c => {
      $$('[data-cart-count]').forEach(n => { n.textContent = c.item_count; n.hidden = !c.item_count; });
      total.textContent = money(c.total_price);
      if (checkout) checkout.hidden = !c.item_count;
      if (!c.items.length) {
        items.innerHTML = '<div class="rbxp-empty"><span class="rbxp-empty__ico" aria-hidden="true">🗑️</span><div><b>Tu carrito está vacío.</b><br>Añade tu RetrobeltXP Belt para empezar.</div></div>';
        return;
      }
      items.innerHTML = c.items.map((it, k) => `
        <div class="rbxp-line">
          <img src="${esc(C.demo ? it.image : img(it.image))}" alt="" width="76" height="76" loading="lazy">
          <div>
            <div class="rbxp-line__t">${esc(it.product_title || it.title)}</div>
            ${it.variant_title ? `<small>${esc(it.variant_title)}</small>` : ''}
            <div class="rbxp-line__row">
              <div class="rbxp-qty"><button type="button" data-line="${k + 1}" data-q="${it.quantity - 1}" aria-label="Quitar uno">−</button><span>${it.quantity}</span><button type="button" data-line="${k + 1}" data-q="${it.quantity + 1}" aria-label="Añadir uno">+</button></div>
              <strong>${money(it.final_line_price)}</strong>
            </div>
          </div>
        </div>`).join('');
    };
    const refresh = () => api.get().then(paint).catch(() => {});
    const open = () => {
      lastFocus = document.activeElement; cart.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
      refresh(); const cb = $('.rbxp-cart__close', cart); cb && cb.focus();
    };
    const close = () => { cart.classList.remove('is-open'); document.documentElement.style.overflow = ''; lastFocus && lastFocus.focus && lastFocus.focus(); };
    window.RBXPCart = { open, refresh };
    $$('[data-cart-open]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); open(); }));
    $$('[data-cart-close]', cart).forEach(a => a.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && cart.classList.contains('is-open')) close(); });
    items.addEventListener('click', e => {
      const b = e.target.closest('[data-line]'); if (!b) return;
      b.disabled = true;
      api.change(+b.dataset.line, Math.max(0, +b.dataset.q)).then(paint).catch(() => { location.href = C.cartUrl; });
    });
  }

  /* ---------- add to cart (AJAX with normal-submit fallback) ---------- */
  $$('form.rbxp-form').forEach(form => form.addEventListener('submit', e => {
    if (!window.fetch || !window.RBXPCart) return;
    e.preventDefault();
    const btn = $('[data-add]', form), msg = $('[data-msg]', form);
    const label = btn.textContent;
    btn.disabled = true; btn.textContent = 'CARGANDO…'; msg.className = 'rbxp-msg'; msg.textContent = '';
    api.add(new FormData(form))
      .then(() => { msg.textContent = '✔ RetrobeltXP_Belt copiado a MY_CART'; window.RBXPCart.open(); })
      .catch(err => { msg.className = 'rbxp-msg is-err'; msg.textContent = '✖ ' + err.message; })
      .finally(() => { btn.disabled = false; btn.textContent = label; });
  }));

  /* ---------- mobile sticky buy bar ---------- */
  const sticky = $('[data-sticky]'), hero = $('[data-hero]') || $('[data-buy-zone]'), zones = $$('[data-buy-zone]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    const vis = new Map(); const link = $('a,button', sticky);
    const upd = () => { const on = ![...vis.values()].some(Boolean); sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on)); link.tabIndex = on ? 0 : -1; };
    const ob = new IntersectionObserver(es => { es.forEach(e => vis.set(e.target, e.isIntersecting)); upd(); }, { threshold: .15 });
    [hero, ...zones, $('.rbxp-foot')].filter(Boolean).forEach(z => { vis.set(z, true); ob.observe(z); });
  }

  /* ---------- taskbar clock ---------- */
  const clk = $('[data-clock]');
  if (clk) {
    const tick = () => { const d = new Date(); clk.textContent = d.toLocaleTimeString(C.locale, { hour: '2-digit', minute: '2-digit' }); clk.dateTime = d.toISOString(); };
    tick(); setInterval(tick, 15000);
  }
})();
